import type { CourseEvaluatorReviewItemType } from "../types/reviewTypes";

export const COURSE_EVALUATOR_REVIEW_ITEM_TYPE_LABELS: Record<CourseEvaluatorReviewItemType, string> = {
  assignment: "Assignment",
  moduleDescription: "Module Description",
  externalLink: "External Link",
  discussion: "Discussion",
  checklist: "Checklist",
  project: "Project",
  quiz: "Quiz",
  file: "File Topic",
  resource: "Resource",
  htmlContent: "HTML Content",
  link: "External Link",
  ile: "Axio ILE",
  page: "Page",
  webpage: "Webpage",
};
